<script setup lang="ts">
import CatalogIndex from '@/views/catalog/CatalogIndex.vue'

/**
 * Catálogo de sets.
 *
 * Búsqueda y filtro de `nacional`/`premium`, que aquí sí existen porque la tabla
 * `sets` tiene la columna. El cuerpo vive en `CatalogIndex.vue`, que es el mismo
 * para las dos pantallas del catálogo.
 */
</script>

<template>
  <CatalogIndex kind="sets" />
</template>
